<template>
  <BaseCard
    title="General Sample Information"
    :step-component="'SampleInformationStep'"
    class="mb-5"
    :edit="edit"
  >
    <div class="review">
      <div v-if="created">
        Created Date: <span>{{ formatDate(created) }}</span>
      </div>
      <div v-if="received_at">
        Received Date: <span>{{ formatDate(received_at) }}</span>
      </div>
      <div v-if="farm_id">
        Farm Name:
        <span>{{
          farmTitle ? farmTitle : farmTitleForEdit ? farmTitleForEdit : "N/A"
        }}</span>
      </div>
      <div v-if="source_other">
        Other Farm Name/ID: <span>{{ source_other }}</span>
      </div>
      <div v-if="quick_feed_type">
        Quick Feed Type: <span>{{ quick_feed_type.title }}</span>
      </div>
      <div v-if="feed_class">
        Feed Category:
        <span>{{
          (getById("feed_classes", feed_class) || {}).title || "N/A"
        }}</span>
      </div>
      <div v-if="feed_type_id">
        Feed Type:
        <span>{{
          (getById("feed_types", feed_type_id) || {}).title || "N/A"
        }}</span>
      </div>
      <div v-if="description">
        Description: <span>{{ description }}</span>
      </div>
      <div v-if="is_preground !== null">
        Pregound: <span>{{ is_preground ? "Yes" : "No" }}</span>
      </div>
      <div v-if="dry_matter_method">
        Dry Matter Method: <span>{{ dry_matter_method }}</span>
      </div>
      <div v-if="grind_method">
        Grind Method: <span>{{ grind_method }}</span>
      </div>
      <div v-if="grind_size">
        Grind Size: <span>{{ grind_size }}</span>
      </div>
      <div v-if="date_collected">
        Sampled Date:
        <span>{{ date_collected }}</span>
      </div>
      <div v-if="date_harvested">
        Harvest Date:
        <span>{{ date_harvested | formatDate }}</span>
      </div>
      <div v-if="cutting">
        Cutting: <span>{{ cutting }}</span>
      </div>
      <div v-if="linked_samples[0]">
        Linked Samples:
        <ul>
          <li v-for="item in linked_samples" :key="item">
            Reference ID: <span>{{ item.id }}</span>
          </li>
        </ul>
      </div>
      <div v-if="sample_condition && sample_condition.length">
        Sample Condition:
        <span>{{ sample_condition }}</span>
      </div>
      <div v-if="crop_year">
        Crop Year:
        <span>{{ crop_year }}</span>
      </div>
    </div>
  </BaseCard>
</template>

<script>
import BaseCard from "@/components/newSamples/ReviewStepCards/BaseCard";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import dayjs from "dayjs";

export default {
  name: "GeneralSampleInformation",
  components: { BaseCard },
  props: ["edit"],
  computed: {
    ...mapFields("samples", [
      "active_sample.farm_id",
      "active_sample.created",
      "active_sample.received_at",
      "active_sample.feed_type_id",
      "active_sample.description",
      "active_sample.is_preground",
      "active_sample.grind_size",
      "active_sample.dry_matter_method",
      "active_sample.grind_method",
      "active_sample.date_collected",
      "active_sample.date_harvested",
      "active_sample.cutting",
      "active_sample.is_linked",
      "active_sample.linked_samples",
      "active_sample.sample_condition",
      "active_sample.crop_year",
      "active_sample.source_other",
      "active_sample"
    ]),
    ...mapFields("sampleWizard", [
      "wizard.quick_feed_type",
      "wizard.feed_class"
    ]),
    ...mapGetters("baseData", ["getById"]),
    ...mapGetters("farms", { farms: "getActiveItems" }),
    ...mapGetters("farms", { getFarmByID: "getById" }),
    farmTitle() {
      return this.getFarmByID(this.farm_id).title;
    },
    farmTitleForEdit() {
      return this.farms.some(farm => farm.id == this.farm_id)
        ? this.farms.find(farm => farm.id == this.farm_id).title
        : null;
    }
  },
  methods: {
    formatDate: function(value) {
      if (value) {
        return dayjs(String(value)).format("MM/DD/YYYY");
      }
    }
  }
};
</script>

<style scoped></style>
